module.exports = __webpack_public_path__ + "img/pc_p3_y4.1f0b6827.png";